import React from 'react';

const TransactionLoadingSkeleton = ({ count = 4 }: { count?: number }) => {
    const widths = [
        { pill: 54, mono: 36, type: 62, desc: '62%', date: 38 },
        { pill: 54, mono: 32, type: 54, desc: '48%', date: 34 },
        { pill: 50, mono: 28, type: 58, desc: '55%', date: 36 },
        { pill: 54, mono: 30, type: 62, desc: '40%', date: 34 },
    ];

    return (
        <>
            {Array.from({ length: count }).map((_, i) => {
                const w = widths[i % widths.length];
                const style = { animationDelay: `${i * 0.15}s` };
                return (
                    <div className="tx-row sk-tx-row" key={i}>
                        <span><div className="sk sk-pill" style={{ width: w.pill, ...style }} /></span>
                        <span><div className="sk sk-mono" style={{ width: w.mono, ...style }} /></span>
                        <span><div className="sk sk-pill" style={{ width: w.type, ...style }} /></span>
                        <span><div className="sk sk-text" style={{ width: w.desc, ...style }} /></span>
                        <span><div className="sk sk-date" style={{ width: w.date, ...style }} /></span>
                    </div>
                );
            })}
        </>
    );
};

export default TransactionLoadingSkeleton;